/*
  Social proof logos — certification arc + recognition marquee.

  Each group ([data-sp-group]) has logo buttons ([data-sp-target]) and one
  detail panel with a detail per logo ([data-sp-detail]).

  - Desktop (hover-capable pointer): hover only. Hovering a logo shows its
    detail; leaving it hides it. Clicks do nothing.
  - Touch: a tap pins the detail; the same logo again releases it.
    A different logo switches the detail. Tapping outside releases it.
  - Keyboard: focusing a logo shows it, Escape hides it.

  While a detail is shown the marquee stops ([data-sp-marquee].is-paused).
  Marquee clones share the target id, so every copy of a logo lights up
  together.
*/
(function () {
  const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initGroup(group) {
    if (group.dataset.spReady) return;
    group.dataset.spReady = 'true';

    const marquee = group.querySelector('[data-sp-marquee]');
    const hint = group.querySelector('[data-sp-hint]');
    let active = null;
    let pinned = false;

    function render() {
      group.querySelectorAll('[data-sp-target]').forEach((button) => {
        const isActive = button.dataset.spTarget === active;
        button.classList.toggle('is-active', isActive);
        if (button.hasAttribute('aria-pressed')) {
          button.setAttribute('aria-pressed', String(isActive && pinned));
        }
      });
      group.querySelectorAll('[data-sp-detail]').forEach((detail) => {
        detail.classList.toggle('is-active', detail.dataset.spDetail === active);
      });
      if (hint) hint.classList.toggle('is-active', !active);
      group.classList.toggle('has-active', Boolean(active));
      if (marquee) marquee.classList.toggle('is-paused', Boolean(active));
    }

    function show(id, pin) {
      active = id;
      pinned = pin;
      render();
    }

    function clear() {
      active = null;
      pinned = false;
      render();
    }

    const targetOf = (event) => event.target.closest('[data-sp-target]');

    group.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse' || pinned) return;
      const target = targetOf(event);
      if (target) show(target.dataset.spTarget, false);
    });

    group.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse' || pinned) return;
      const target = targetOf(event);
      if (!target || target.contains(event.relatedTarget)) return;
      clear();
    });

    group.addEventListener('click', (event) => {
      const target = targetOf(event);
      if (!target || hoverDevice.matches) return;
      const id = target.dataset.spTarget;
      if (active === id && pinned) {
        clear();
      } else {
        show(id, true);
      }
    });

    group.addEventListener('focusin', (event) => {
      const target = targetOf(event);
      if (!target || pinned || !target.matches(':focus-visible')) return;
      show(target.dataset.spTarget, false);
    });

    group.addEventListener('focusout', (event) => {
      if (pinned || group.contains(event.relatedTarget)) return;
      if (active) clear();
    });

    group.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && active) clear();
    });

    document.addEventListener('click', (event) => {
      if (active && pinned && !group.contains(event.target)) clear();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sp-group]').forEach(initGroup);
  }

  initAll();
  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', initAll);
})();
